import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

type PlatoScoreTagVariant = "light" | "medium" | "linear";

interface Props {
  children: React.ReactNode;
  variant?: PlatoScoreTagVariant;
  size?: number;
}

const PlatoScoreTag: React.FunctionComponent<Props> = ({ children, variant = "medium", size = 26 }) => {
  if (variant === "linear") {
    return <Styled.Linear style={{ height: size }}>{children}</Styled.Linear>;
  }
  if (variant === "light") {
    return <Styled.Light style={{ height: size }}>{children}</Styled.Light>;
  }
  return <Styled.Medium style={{ height: size }}>{children}</Styled.Medium>;
};

export default PlatoScoreTag;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

const baseStyles = (t: any) => css`
  display: inline-flex;
  align-items: center;
  ${[t.px(2), t.rounded.xs]}
  height: 26px;
  font-size: 0.8125rem;
  line-height: 1.4;
  padding-top: 2px;
  white-space: nowrap;
`;

Styled.Light = styled.span((props: any) => {
  const t: any = props.theme;
  return css`
    label: PlatoScoreTag_Light;
    ${baseStyles(t)}
    border: 1px solid ${t.dark ? t.color.gray[600] : t.color.gray[200]};
    color: ${t.dark ? t.color.gray[200] : t.color.gray[900]};
  `;
});

Styled.Medium = styled.span((props: any) => {
  const t: any = props.theme;
  return css`
    label: PlatoScoreTag_Medium;
    ${baseStyles(t)}
    border: 1px solid ${t.dark ? t.color.gray[200] : t.color.black};
    color: ${t.dark ? t.color.gray[200] : t.color.black};
  `;
});

Styled.Linear = styled.span((props: any) => {
  const t: any = props.theme;
  return css`
    label: PlatoScoreTag_Linear;
    ${baseStyles(t)}
    background: linear-gradient(120deg, #fbd7ff 10%, #ffdec1 90%);
    border: 1px solid rgba(0, 0, 0, 0.07);
    color: ${t.color.black};
  `;
});
